import React, {useState} from 'react';
import FsLightbox from 'fslightbox-react';
import { getFullImageUrl } from '../utils/apiBase';

const FloorPlan = ({...props}) => {
    const [toggler, setToggler] = useState(false); 
    const [currentSlide, setCurrentSlide] = useState(1);
    const floorPlanData = props.floorPlanData;

    // Flatten all image URLs into a single array
    const allImages = floorPlanData.flatMap(detail => [
        <div className="text-center">
            <img src={`${getFullImageUrl(detail.floorimg1_path)}`} alt={`${detail.floorsize} ( ${detail.floortitle1} )`} className='max-h-fit' />
            <div className="text-base font-semibold text-white mt-3">{detail.floorsize} ( {detail.floortitle1} ) </div>
        </div>,
        <div className="text-center">
            <img src={`${getFullImageUrl(detail.floorimg2_path)}`} alt={`${detail.floorsize} ( ${detail.floortitle2} )`} className='max-h-fit' />
            <div className="text-base font-semibold text-white mt-3">{detail.floorsize} ( {detail.floortitle2} )</div>
        </div>
    ]);

    const openLightbox = (index) => {
        setCurrentSlide(index + 1); // FsLightbox is 1-based
        setToggler(!toggler);
    };

    return (
        <div className='flex flex-col py-4 bg-white'>
            <h2 className='text-xl leading-8 font-bold uppercase font-montserrat pb-2 mb-4 text-gray-900 text-center border-b border-gray-200 border-solid'>{props.title}</h2>
            {/* <div className='grid grid-cols-1 gap-6'> */}
            <div className='flex flex-wrap items-start justify-center gap-6'>
                {floorPlanData.map((floorDetail, idx)=>{
                    const imgIndex1 = idx * 2;     // position in allImages
                    const imgIndex2 = idx * 2 + 1; // position in allImages
                    return (
                <div className='flex flex-col basis-full md:basis-[calc(50%-0.75rem)] justify-center box-shadow rounded-xl p-4' key={idx}>
                    <h2 className='text-lg leading-7 font-bold uppercase font-montserrat mb-2 text-gray-900 bg-gray-100 text-center'>{floorDetail.floorsize}</h2>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                        <div className='flex flex-col w-full h-full justify-center items-center space-y-1'>
                            <div className='w-full h-full flex items-center bg-white justify-center'>
                                <img src={getFullImageUrl(floorDetail.floorimg1_path)} alt={`Floor Plan for ${floorDetail.floorsize} - ${floorDetail.floortitle1}`} onClick={() => openLightbox(imgIndex1)} className='max-h-96' />
                            </div>
                            <div className='text-base font-semibold'>{floorDetail.floortitle1}</div>
                        </div>
                        <div className='flex flex-col w-full h-full justify-center items-center space-y-1'>
                            <div className='w-full h-full flex items-center bg-white justify-center'>
                                <img src={getFullImageUrl(floorDetail.floorimg2_path)} alt={`Floor Plan for ${floorDetail.floorsize} - ${floorDetail.floortitle2}`} onClick={() => openLightbox(imgIndex2)} className='max-h-96' />
                            </div>
                            <div className='text-base font-semibold'>{floorDetail.floortitle2}</div>
                        </div>
                    </div>
                </div>
                )}
            )}                
            </div>
            {/* Single lightbox for all images */}
            <FsLightbox
                toggler={toggler}
                sources={allImages}
                slide={currentSlide}
            />
        </div>
    );
}

export default FloorPlan;
